import React from 'react';

import { AnchorParams, Link } from './anchor';

export const LinkContainer: React.FC<AnchorParams> = ({ className, ...params }: AnchorParams) => {
  const fullClassname = ['link', className].join(' ').trim();

  return <Link className={fullClassname} {...params} />;
};
